var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 17" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-attention"] || "oc-icon-status-attention"), d: "M16.3 12l-.1-2.1c0-2.5-1.6-4.7-4-5.5.2-1-.6-2-1.6-2.2s-2 .6-2.2 1.6v.6c-2.4.8-4 3-4 5.5V12c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h4.4c-.2.8.2 1.7 1.1 1.9.8.2 1.7-.2 1.9-1.1.1-.3.1-.6 0-.9h4.4c.7 0 1.3-.5 1.3-1.2.1-.7-.5-1.3-1.2-1.3zM1.5 9c-.4 0-.8-.3-.8-.7-.9-3.5 1.2-7 4.7-7.9.5-.1.9.2 1.1.6.2.4-.2.9-.6 1.1-2.6.6-4.1 3.2-3.5 5.8 0 .5-.3.9-.7 1l-.2.1zM19.4 9c.4 0 .8-.3.9-.7.9-3.5-1.2-7-4.7-7.9-.5-.1-.9.2-1.1.6-.1.5.2.9.6 1.1 2.6.6 4.1 3.2 3.5 5.8-.1.5.2.9.6 1.1h.2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Alert.svg